module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-google-maps/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 2183
// module chunks = 0